import { useState, useEffect } from "react";
import { Header } from "./shared/header";
import { Navigation } from "./shared/navigation";
import { Footer } from "./shared/footer";
import { Section } from "./shared/types";
import { Route, useLocation, Routes } from "react-router-dom";
import "swiper/css";
import "react-perfect-scrollbar/dist/css/styles.css";

import { sectionData } from "data/sections";
import { Home } from "./shared/home";
import { Diss } from "./shared/projects/diss";
import { Organization } from "shared/organization";
import Collabora from "shared/collabora";
import Pangea from "shared/projects/pangea";
import Blast from "shared/projects/blast";
import Bubble from "shared/projects/bubble";
import { By } from "shared/projects/by";

function App() {
  const [menuOpen, setMenuOpen] = useState<boolean>(false);
  const [currentSection, setCurrentSection] = useState<Section>(null);

  const [background, setBackground] = useState<string>("");

  const { pathname } = useLocation();

  const onChangeSection = (): Section => {
    if (pathname === "/") {
      return "MAGOG";
    }

    const urlPath = pathname.slice(1); // Remove leading slash
    const section = sectionData.find(data => data.url === urlPath);

    return section?.section ?? "MAGOG";
  };

  useEffect(() => {
    if (pathname === "/" && currentSection !== "MAGOG") {
      const section = document.querySelector(
        `[data-section="${currentSection}"]`
      );
      const top = section?.getBoundingClientRect().top;
      window.scrollTo(0, top || 0);
    } else {
      window.scrollTo(0, 0);
    }

    const current = onChangeSection();

    const bg = getCurrentBg(current);
    setCurrentSection(current);
    setBackground(bg);
    // eslint-disable-next-line
  }, [pathname]);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };
  const closeMenu = () => {
    setMenuOpen(false);
  };

  const navigateSection = (section: Section) => {
    // setCurrentSection(section);
  };

  const getCurrentBg = (current: Section): string => {
    if (current === "MAGOG" || !current) {
      return "#7e00e4";
    }

    const section = sectionData.find(data => data.section === current);
    return section?.bg ?? "#050505";
  };

  return (
    <div
      className={`App ${currentSection}`}
      style={{ backgroundColor: background }}
    >
      <Header
        section={currentSection}
        toggleMenu={toggleMenu}
        menuOpen={menuOpen}
        navigateSection={navigateSection}
      />
      <Navigation
        section={currentSection}
        closeMenu={closeMenu}
        menuOpen={menuOpen}
      />

      <Routes>
        <Route path="/organigramma" element={<Organization />} />
        <Route
          path="/bayram"
          element={<By {...sectionData.find(s => s.url === "bayram")!} />}
        />
        <Route
          path="/bubble-report"
          element={<Bubble {...sectionData.find(s => s.url === "bubble-report")!} />}
        />
        <Route
          path="/blast"
          element={<Blast {...sectionData.find(s => s.url === "blast")!} />}
        />
        <Route
          path="/pangea"
          element={<Pangea {...sectionData.find(s => s.url === "pangea")!} />}
        />
        <Route
          path="/dissipatio"
          element={<Diss {...sectionData.find(s => s.url === "dissipatio")!} />}
        />
        <Route path="/collabora" element={<Collabora />} />
        <Route
          path="/"
          element={
            <Home
              navigateSection={navigateSection}
              currentSection={currentSection}
            />
          }
        />
        <Route
          path="*"
          element={
            <div className="container full m-auto bg-black color-white">
              <div className="collabora  ">
                <div className="collabora-intro">
                  <b className="text-align-center">Ops, pagina non trovata.</b>
                </div>
              </div>
            </div>
          }
        />
      </Routes>

      <Footer />
    </div>
  );
}

export default App;
